import { useOfflineStatus } from "@/components/offline/OfflineContext";

export const ConnectivityIndicator = () => {
  const { isOffline } = useOfflineStatus();
  
  return (
    <div className="flex items-center gap-1" title={isOffline ? "Offline" : "Online"}>
      <div 
        className={`w-2 h-2 rounded-full ${isOffline ? 'bg-red-500' : 'bg-green-500'}`}
        aria-label={isOffline ? "Offline" : "Online"}
      />
      <span className="hidden lg:inline text-[10px] opacity-70 select-none">
        {isOffline ? "Offline" : "Online"}
      </span>
    </div>
  );
};